import React from 'react';
import { Form, Switch, Radio, Space, Tooltip } from 'udesk-ui';
import { QuestionCircleOutlined } from '@ant-design/icons';
import UdeskLocales from 'UdeskLocales';

export const RandomBranchConfig = React.memo((props: any) => {
    const { value, onChange, childNodes } = props;
    if (!childNodes || childNodes.length < 2) return null;
    return (
        <React.Fragment>
            <Form.Item style={{ marginBottom: 0 }}>
                <Space>
                    <div>{/* 下一步节点随机触发 */}{UdeskLocales['current'].components.coach.randomBranchConfig.index.nextNodeRandomTrigger}</div>
                    <Tooltip
                        overlayInnerStyle={{
                            whiteSpace: 'pre-wrap',
                        }}
                        title={/* 若开启用户画像，节点路径将以用户画像和默认话术为主，随机功能不生效 */UdeskLocales['current'].components.coach.randomBranchConfig.index.ifTheUserPortraitIsEnabledTheNodePathWillBeBasedOnTheUserPortraitAndDefaultSpeechAndTheRandomFunctionWillNotTakeEffect}
                    >
                        <QuestionCircleOutlined />
                    </Tooltip>
                    <Switch size="small" checked={!!Number(value)} onChange={onChange} />
                </Space>
            </Form.Item>
            {!!Number(value) && (
                <Form.Item
                    name="wordRandomMode"
                    wrapperCol={{ offset: 2 }}
                    rules={[{ required: true, message: /* 请选择随机模式 */UdeskLocales['current'].components.coach.randomBranchConfig.index.pleaseSelectRandomMode }]}
                >
                    <Radio.Group>
                        <Radio value={1}>{/* 完全随机 */}{UdeskLocales['current'].components.coach.randomBranchConfig.index.completelyRandom}</Radio>
                        <Radio value={2}>{/* 路径覆盖随机 */}{UdeskLocales['current'].components.coach.randomBranchConfig.index.pathCoverageRandom}</Radio>
                    </Radio.Group>
                </Form.Item>
            )}
        </React.Fragment>
    );
});
